/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ReportTemplateColumnSettingBulkInsertInner { 
    /**
     * Foreign key to ReportTemplates table. Unique with column_name.
     */
    reportTemplateId?: number;
    /**
     * Name of the column in the report.
     */
    columnName?: string;
    /**
     * TRUE if the column is visible in this template.
     */
    isVisible?: boolean;
    /**
     * Order of the column for display purposes.
     */
    columnOrder?: number;
    /**
     * TRUE if the grid should group by this column. Default: FALSE
     */
    isGrouped?: boolean;
    /**
     * Order in which this column is grouped (if grouped by multiple columns).
     */
    groupOrder?: number;
    /**
     * Sort direction for this column, e.g., 'ASC' for ascending, 'DESC' for descending.
     */
    sortDirection?: string;
    /**
     * Order in which columns are sorted (if sorted by multiple columns).
     */
    sortOrder?: number;
}